import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'
import Spinner from '../Spinner/Spinner'
import { CARD_ITEMS_QUERY } from '../../graphql.js'
import MenuCardBody from './MenuCardBody'

const CARD_ITEMS = gql(CARD_ITEMS_QUERY)

export default function MenuCardBodyContainer({ card }) {
  const { loading, error, data } = useQuery(CARD_ITEMS, {
    variables: { cardId: card.id },
    fetchPolicy: 'cache-first'
  })

  if (error) return `Error! ${error.message}`
  if (loading || !data) return <Spinner />
  if (data.cardItems) return <MenuCardBody items={data.cardItems} />
  return ''
}
